import { Component, OnInit, ViewChild, ElementRef, HostListener, TemplateRef } from '@angular/core';
import { StatePersistService } from 'src/app/core/services/state-persist.service';
import { ProductService } from '../../services/product.service';
import { environment } from 'src/environments/environment';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { AlertService } from 'src/app/core/services/alert.service';
import { CartService } from 'src/app/cart/services/cart.service';
import { Title } from '@angular/platform-browser';
import { ProductConsts } from '../../constants';
import { Router } from '@angular/router';
@Component({
    selector: 'suggested-products',
    templateUrl: './suggested-products.component.html',
    styleUrls: ['./suggested-products.component.scss'],
    standalone: false
})
export class SuggestedProductsComponent implements OnInit {
  bsModalRef: BsModalRef;
  loading = false
  contentLoaded = false
  sortBy = 'short_desc'
  order = 'asc'
  pageSize = environment.product_listing_page_size;
  profileImagePath = environment.s3_path + '/' + environment.profileFolder
  imagePath = environment.s3_path + '/' + environment.product_image_folder + '/'
  nextPage = 1;
  productList = []
  totalProductPages = 1;
  totalProductCount = 0;
  noRecord = true;
  commonBottonText: any = 'Ok';
  removeProduct = {};
  removeHeading = ''
  popupMessage = ''
  salesRepDetail = {}
  miniCartDetails: any;
  selectedSort = 3;
  selectedStore: any;
  global_data:any = {};
  constructor( private statePersiste: StatePersistService, private productService: ProductService,
    private alertService: AlertService,
    private titleService: Title,
    private modalService: BsModalService,
    private cartService: CartService,
    private router: Router,
  ) {
    
  }

  ngOnInit(): void {
    this.statePersiste.watchGlobalDataStorage().subscribe(message => {
      this.global_data = this.statePersiste.getLocalStorage('global_data')
    })
    this.titleService.setTitle(ProductConsts.SUGGESTED_PAGE_TITLE);
    this.productListing()
    this.salesrepDetail()
    this.selectedStore = this.statePersiste.getLocalStorage('selectedStoreAddress')
    this.miniCartDetails = this.statePersiste.getLocalStorage('mini_cart_details')
    this.statePersiste.watchMiniCartDetailChange().subscribe(message => {
      this.miniCartDetails = this.statePersiste.getLocalStorage('mini_cart_details')
    })
    this.statePersiste.watchSuggestedPRoductListing().subscribe(message => {
      this.productList = [];
      this.nextPage = 1;
      this.totalProductCount = 0;
      this.totalProductPages = 1
      this.productListing()
      this.salesrepDetail()
      this.statePersiste.emitstoreListing('store list update')
    })
  }
  
  @ViewChild('stickyMenu') menuElement: ElementRef;

  sticky: boolean = true;
  elementPosition: any;
  @HostListener('window:scroll', ['$event'])
  handleScroll() {
    const windowScroll = window.pageYOffset;
    if (windowScroll >= this.elementPosition) {
      this.sticky = false;
    } else {
      this.sticky = true;
    }
  }

  productSort(selectedSort, by, order){
    this.selectedSort = selectedSort
    this.sortBy = by
    this.order = order
    this.productList = [];
    this.nextPage = 1;
    this.totalProductCount = 0;
    this.totalProductPages = 1
    this.productListing()
  }

  notInteretedSuggest(product){
    this.productService.notInterestProduct({'product_id': product.product_id, 'recommendation_id':''})
        .subscribe(
          data => {
            console.log('success')
          }
        );
  }

  salesrepDetail(){
    this.productService.storeSuggestBanner()
      .subscribe(
        data => {
          if (data.response) {
            this.salesRepDetail = data.response;

          }

        }
      );
  }
  productListing() {
    const formdata = {
      "sort": this.sortBy, "order": this.order,
      "page_size": this.pageSize,"page": this.nextPage,
    }
    
    this.productService.suggestBannerProducts(formdata)
      .subscribe(
        data => {
          if (data.response) {
            const product_list = data.response.products;
            this.totalProductCount = data.response.total_product_count
            this.totalProductPages = data.response.total_pages;
            if (this.totalProductPages < this.nextPage + 1) {
              this.nextPage = null;
            }
            else {
              this.nextPage += 1;
            }

           if (data.response.total_product_count === 0) {
              this.noRecord = true;
              this.productList = [];
              this.nextPage = 1;
              this.totalProductCount = 0;
              this.totalProductPages = 1
            }
            else {
              this.noRecord = false;

            }
            for (let i = 0; i < product_list.length; i++) {
              this.productList.push(product_list[i]);
            }
          }
          this.contentLoaded = true;
          this.loading = false;
        }
      );
  }

  onScrollDown() {
    if ((this.nextPage != 1 && this.nextPage !== null) && !this.loading) {
      this.loading = true;
      this.productListing()
    }

  }

  toInteger(value) {
    return parseInt(value)
  }
  popup(template: TemplateRef<any>){
    this.bsModalRef = this.modalService.show(template,  Object.assign({}, { class: 'modal-dialog-centered custom-modal confirm' }));
  }
  addToCart(product, qyt, template: any, type: any, template2:any) {
    let dataObj; 
    if (product.qty == '') {
      qyt = '1'
    }
    dataObj = {
      "cart_item": {
        "sku": product.sku,
        "qty": qyt
      }
    }
    this.productService.addToCart(dataObj)
      .subscribe(
        data => {
          if (data.response) {
            this.popupMessage = ''
            if (data.status == 2212) {
              this.alertService.error(data.response.msg)
              for (let i = 0; i < this.productList.length; i++) {
                if (this.productList[i]['product_id'] == product.product_id) {
                  this.productList[i]['qty'] = '1'
                }
            }
            }
            else if (data.status == 1169) {
              for (let i = 0; i < this.productList.length; i++) {
                if (this.productList[i]['product_id'] == product.product_id) {
                  this.productList[i]['qty'] = '1'
                  this.productList[i]['back_in_stock'] = '0'
                }
              }
            }
            else if(data.status == 1180){
              localStorage.setItem('closeStorInfoMessage', data.response.msg)
              document.getElementById("openclosedStoreInfo").click();
              for (let i = 0; i < this.productList.length; i++) {
                if (this.productList[i]['product_id'] == product.product_id) {
                  this.productList[i]['qty'] = '1'
                }
            }
            }
            else if (data.status == 1168) {
              for (let i = 0; i < this.productList.length; i++) {
                if (this.productList[i]['product_id'] == product.product_id) {
                  this.productList[i]['qty'] = '1'
                  this.productList[i]['back_in_stock'] = '0'
                }
              }
              this.popupMessage = data.response
              this.commonBottonText = "Ok, Don't show this again"
              this.popup(template2)
              
              // this.alertService.success(data.response)
            }
            else if (data.status == 1163) {
              this.alertService.error(data.response)
              this.productList = this.productList.filter(item => item.product_id !== product.product_id);
              
            }
            else {
              for (let i = 0; i < this.productList.length; i++) {
                if (this.productList[i]['product_id'] == product.product_id) {
                  this.productList[i]['qty'] = String(qyt)
                  this.productList[i]['item_id'] = data.response.item_id
                }
              }
              var storeCount
              storeCount = this.statePersiste.getLocalStorage('selectedStoreAddress')
              if (template && storeCount['totalStoreCount'] > 1){
                this.popup(template)
              }

            }
            this.statePersiste.emitminiCartData('min cart update')

          }

        }
      );
    // Set boolean class on click of add button   
  }

  removeItem(product){
    let fordata;
    fordata = {'item_id': product.item_id}
    this.cartService.removeItem(fordata)
      .subscribe(
        data => {
          if (data.response) {
            if(data.status == 1180){
              localStorage.setItem('closeStorInfoMessage', data.response.msg)
              document.getElementById("openclosedStoreInfo").click();
              const currentUrl = this.router.url;
              this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
                this.router.navigate([currentUrl]);
              });
            }
            else if (data.status == 2212){
              this.alertService.error(data.response)
            }
            else{
              for (let i = 0; i < this.productList.length; i++) {
                if (this.productList[i]['product_id'] == product.product_id) {
                  this.productList[i]['back_in_stock'] = ''
                  this.productList[i]['item_id'] = ''
                }
              }
              this.statePersiste.emitminiCartData('update mini cart')
              this.alertService.success('Product removed.')
            }
            
          }
            
          }

      )

  }

  qytChange(product, qyt, template,template2: any, type:any) {
    
    if (product.item_id !== '') {
      if (qyt == 0){
        for (let i = 0; i < this.productList.length; i++) {
          if (this.productList[i]['product_id'] == product.product_id) {
            this.productList[i]['qty'] = 0
          }
        }
        this.removeItem(product)
      }else{
        this.qytUpdate(product, String(qyt), template)
      }
      
    }
    else {
      for (let i = 0; i < this.productList.length; i++) {
        if (this.productList[i]['product_id'] == product.product_id) {

          this.productList[i]['qty'] = String(qyt)
        }
      }
    }
  }

  qytUpdate(product, qyt, template) {
    this.productService.qytUpdate({ 'item_id': parseInt(product.item_id), 'qty': qyt })
      .subscribe(
        data => {
          if (data.response) {
            this.popupMessage = ''
            if (data.status == 1169) {
              for (let i = 0; i < this.productList.length; i++) {
                if (this.productList[i]['product_id'] == product.product_id) {
                  this.productList[i]['qty'] = '1'
                  this.productList[i]['item_id'] = ''
                  this.productList[i]['back_in_stock'] = '0'
                }
              }
            }
            else if(data.status == 2212){
              this.alertService.error(data.response)
              for (let i = 0; i < this.productList.length; i++) {
                if (this.productList[i]['product_id'] == product.product_id) {
                  this.productList[i]['qty'] = data.response.qty
                }
            }}
            else if(data.status == 1180){
              localStorage.setItem('closeStorInfoMessage', data.response.msg)
              document.getElementById("openclosedStoreInfo").click();
              for (let i = 0; i < this.productList.length; i++) {
                if (this.productList[i]['product_id'] == product.product_id) {
                  this.productList[i]['qty'] = data.response.qty
                }
            }
            const currentUrl = this.router.url;
              this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
                this.router.navigate([currentUrl]);
              });
            }
            else if (data.status == 1163) {
              this.alertService.error(data.response)
              this.productList = this.productList.filter(item => item.product_id !== product.product_id);
              
            }
            else {
              for (let i = 0; i < this.productList.length; i++) {
                if (this.productList[i]['product_id'] == product.product_id) {
                  this.productList[i]['qty'] = qyt
                }
              }
            }
            this.statePersiste.emitminiCartData('min cart update')

          }

        }
      );
  }

}
